export default {"src":"/_next/static/media/MARKETPLACE_ACTIVE_ICON.09264691.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};